import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import userActions from '../../../user/userActions';

import { Checkbox, FormCheckConditional, TextInput } from '../../../components/forms';
import Utils from '../../../common/utils';

interface Props {
	user: UserDetails;
	questions: any;
	questionnaire: any;
	errors: any;
	actions: any;
	onQuestionnaireBlur?: (e: any) => Promise<any>;
	onQuestionnaireChange?: (e: any) => void;
	onUserChange?: (e: any) => void;
}
interface State {
	touched: {
		email: boolean;
	};
}
class DisclaimerForm extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			touched: {
				email: false
			}
		};
	}

	handleBlur = (field: any) => (evt: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true }
		});
	}

	onPhoneKeyUp = (e: any) => {
		let phone = e.target.value;
		phone = phone
			.match(/\d*/g)
			.join('')
			.match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
			.slice(1)
			.join('-')
			.replace(/-*$/g, '');

		const user = {
			...this.props.user,
			[e.target.name]: phone
		};

		this.props.actions.setUser(user);
	}

	// todo: make sure name gets saved under questionnaire.declareTrueName for auditing
	render() {
		const { ...props } = this.props;
		return (
			<fieldset>
				<p className="max-read-width mx-auto">
					Most insurers require medical exams and bodily fluids before they give you coverage. We offer inexpensive life
					insurance with only a few quick questions. Why? Because Canadians are the most honest people we know!
				</p>
				<p className="max-read-width mx-auto mb-4">
					So, please commit to answering the following questions truthfully and completely, and please don't send us anything
					wet in the mail!
				</p>
				<Checkbox
					name="declareTrue"
					label={props.questions.declareTrue}
					checked={props.questionnaire.declareTrue}
					onBlur={props.onQuestionnaireBlur}
					onChange={props.onQuestionnaireChange}
					conditionalChildren={
						<FormCheckConditional isOpen={props.questionnaire.declareTrue}>
							<div className="row">
								<TextInput
									labelText="First name"
									name="firstName"
									onChange={this.props.onUserChange}
									value={this.props.user.firstName}
									className="col-sm-6 mb-sm-2"
								/>
								<TextInput
									labelText="Last name"
									name="lastName"
									onChange={this.props.onUserChange}
									value={this.props.user.lastName}
									className="col-sm-6 mb-sm-2"
								/>
								<TextInput
									labelText="Email address"
									name="email"
									className="col-sm-12 mb-2"
									onBlur={this.handleBlur('email')}
									onChange={this.props.onUserChange}
									value={this.props.user.email}
									error={
										Utils.shouldMarkError(this.props.errors.email, this.state.touched.email)
											? this.props.errors.email
											: undefined
									}
								/>
								<TextInput
									labelText="Phone Number"
									name="phoneNumber"
									className="col-sm-12 mb-2"
									onChange={this.props.onUserChange}
									onKeyUp={this.onPhoneKeyUp}
									value={this.props.user.phoneNumber}
								/>
							</div>
						</FormCheckConditional>}
					className="form-group"
				/>
				<p className="max-read-width mx-auto mb-0">
					<em>
						By clicking next, you acknowledge and agree to our{' '}
						<Link to="/privacy" target="_blank">Privacy Policy</Link>{' '}
						and{' '}
						<Link to="/terms" target="_blank">Terms of Use</Link>.
					</em>
				</p>
			</fieldset>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		questions: state.question.questions,
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(DisclaimerForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/DisclaimerForm.tsx